import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NavParams, IonicModule } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@core/auth.service';
import { animate, style, transition, trigger } from "@angular/animations";
import { SafeHtmlPipe } from '../../pipe/safehtmlpipe';

@Component({
    selector: 'app-my-toastbar',
    templateUrl: './my-toastbar.component.html',
    styleUrls: ['./my-toastbar.component.scss'],
    animations: [
        trigger('state', [
            transition(':enter', [
                style({ transform: 'translateY(-100%) scale(1)' }),
                animate('150ms cubic-bezier(0.17, 0.04, 0.03, 0.94)', style({
                    opacity: 1,
                    transform: 'translateY(0) scale(1)',
                })),
            ]),
            transition(':leave', [
                animate('150ms cubic-bezier(0.17, 0.04, 0.03, 0.94)', style({
                    opacity: 0,
                    transform: 'translateY(-100%) scale(1)',
                })),
            ]),
        ]),
    ],
    standalone: true,
    imports: [IonicModule, SafeHtmlPipe],
})
export class MyToastbarComponent implements OnInit {

  /*  message: any;
   state: any;
   title: any;
   description: any; */
  public message: string;
  public state: string;
  public description: string;
  public icon: string;
  public subMsgWithDv: string;
  public subMessage: string;
  public duration: number;
  public animationDuration: number;

  /* constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    private _snackRef: MatSnackBarRef<MyToastbarComponent>,) {
    this.message = data?.message;
    this.state = (data?.state).toLowerCase();
    this.description = data?.description;
  } */
  constructor(@Inject(MAT_SNACK_BAR_DATA)
  public data: {
      code?: string;
      message: { line_1: string; line_2?: string };
      description: string;
      style: {
        type: string;
        icon: string;
        duration_ms: number;
      };
      context?: {
        journey?: string;
        trigger?: string;
        reason_code?: string;
      };
    },
    private _snackRef: MatSnackBarRef<MyToastbarComponent>,
    private authService: AuthService,
  ) {
    this.message = data?.message?.line_1 ? data?.message?.line_1 : "Something went wrong!";
    this.subMsgWithDv = data?.message?.line_2;
    this.state = (data?.style?.type).toLowerCase();
    this.description = data?.description;
    this.icon = data?.style?.icon;
    this._snackRef = _snackRef;
    if (this.subMsgWithDv) {
      this.authService.getDVFromString(this.subMsgWithDv).then((dvString: string) => {
        if (dvString) {
          this.subMessage = dvString;
        } else {
          return ''
        }
      }).catch((err) => {
        return err
      });
    }
    if (data?.style?.duration_ms) {
      this.duration = data?.style?.duration_ms;
    }
    else {
      this.duration = 5000;
    }
    this.animationDuration = 150;
  }

  ngOnInit(): void {
    //this.title = "Toastbar Component";
    setTimeout(() => { this.state = '' }, this.duration - this.animationDuration)
  }


  dismissToastr() {
    // this._snackRef.dismiss();
    this.state = '';
    setTimeout(() => {
      this._snackRef.dismiss();
    }, this.animationDuration)
  }

}
